import { commitMutation } from 'react-relay';

export const commit = (environment, args = {}) => {
  return commitMutation(environment, {
    onError: console.error,
    ...args,
  });
};
